import styled from "styled-components";
import { colors, types } from "../../libs/themes";
import { PlayFill } from "react-bootstrap-icons";

export const MediaPoster = styled.div`
    position: relative;

    &.hover-intent:not(.is-mobile) {

        & .media-poster--link {

            & .watch-label {
                visibility: visible;
                opacity: 1;
                transform: translateX(-50%) scale(1);
                transition: opacity 0.3s ease-out 0.15s, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s;
            }
        }

        & .media-poster--art {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            transition: all 0.3s ease-out;
            
            & img {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
                box-shadow: 0px -5px 15px -3px rgba(0, 5, 13, 0.28);
                transition: all 0.3s ease-out;
            }
        }
    }
`;

export const MediaPosterLink = styled.a`
    line-height: 0;
    text-decoration: none;
    width: 100%;
    height: 100%;
    padding: 12px 24px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;

    @media(hover: hover) {
        &:hover {
            cursor: pointer;
        }
    }

    &:focus {
        outline: none;
    }

    & .watch-label {
        background-color: ${colors.background.scrollButtonBg};
        font-size: 14px;
        font-weight: 700;
        line-height: 1.337;
        text-transform: uppercase;
        text-align: center;
        color: ${colors.text.black};
        width: calc(100% - 70px);
        padding: 6px 12px 6px 12px;
        border: 4px solid transparent;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
        box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
        visibility: visible;
        opacity: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: -16px;
        left: 50%;
        z-index: 9999;
        transform: translateX(-50%) scale(1);
        transition: all 0.3s ease-out;
        will-change: opacity, transform;

        @media (min-width: 576px) {
            
        }
        @media (min-width: 768px) {
            &:not(.is-mobile) {
                visibility: hidden;
                opacity: 0;
                transform: translateX(-50%) scale(0.5);
                transition: all 0.3s ease-out;
            }
        }
        @media (min-width: 992px) {
            
        }
        @media (min-width: 1200px) {
            
        }
        @media (min-width: 1400px) {
            
        }
    }
`;

export const MediaPosterArt = styled.div`
    line-height: 0;
    aspect-ratio: 16 / 9;
    background-color: ${({ theme }) => theme.cardSeparator};
    box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }
    @media (min-width: 992px) {
        
    }
    @media (min-width: 1200px) {
        
    }
    @media (min-width: 1400px) {
        
    }
`;

export const MediaPosterImage = styled.img`
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: 50% 50%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    transition: all 0.3s ease-out;

    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }
    @media (min-width: 992px) {
        
    }
    @media (min-width: 1200px) {
        
    }
    @media (min-width: 1400px) {
        
    }
`;

export const MediaAncillary = styled.article`
    background-color: ${({ theme }) => theme.cardBg};
    color: ${({ theme }) => theme.cardText};
    width: 100%;
    max-height: none;
    padding: 0 20px 18px 20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0px 10px 15px -3px rgba(0, 5, 13, 0.5);
    margin-top: -1px;
    opacity: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    position: relative;
    top: auto;
    transition: all 0.3s ease-out;
    will-change: max-height, opacity;

    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            max-height: 0;
            opacity: 0;
            flex: 0 1 auto;
            position: absolute;
            top: 100%;
        }
    }
    @media (min-width: 992px) {
        
    }
    @media (min-width: 1200px) {
        
    }
    @media (min-width: 1400px) {
        
    }

    &.hover-intent:not(.is-mobile) {
        max-height: 420px;
        padding: 0 20px 20px 20px;
        opacity: 1;
        transition: all 0.3s ease-out;
    }

    & section {
        margin-top: 12px;
    }
`;

export const MediaMetadataPlaylist = styled.div`
   ${types.headers.itemMedium};
  line-height: normal;
  margin-top: 12px;

  span {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
  }

   &:last-child {
        margin-bottom: 0;
    }

    & *>:last-child {
        margin-bottom: 0;
    }

    & h4 {
        font-size: 17.01px;
        font-weight: 700;
        line-height: normal;
        text-transform: initial;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: calc(22px * 2);
        margin-top: 28px;
        margin-bottom: 4px;
        display: -webkit-box;
        overflow: hidden;
    }

    & .viewer-rating {
        font-size: 13.01px;
        font-weight: 700;
        line-height: 1.337;
        text-transform: initial;

        & .viewer-rating--filled {
            color: #FFD700;
        }
        & .viewer-rating--empty {
            color: ${colors.text.gray};
        }
    }

    & .release-year {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
    }

    & .duration {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
    }

    & .mpaa-rating {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
        white-space: nowrap;
        min-width: 24px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding-left: 10px;
    }

    & .mpaa-rating>span {
        background: ${colors.background.grey};
        border-radius: 4px;
        color: ${colors.text.white};
        line-height: 1.337;
        white-space: nowrap;
        min-width: 20px;
        padding: 2px 4px 1.01px;
    }
        
`;
export const MediaMetadata = styled.div`
 ${types.body.secondaryTitle}
  font-weight: 700;
  line-height: normal;
  color: ${colors.text.white};
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;

  span {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
  }

   &:last-child {
        margin-bottom: 0;
    }

    & *>:last-child {
        margin-bottom: 0;
    }

    & h4 {
        font-size: 17.01px;
        font-weight: 700;
        line-height: normal;
        text-transform: initial;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: calc(22px * 2);
        margin-top: 28px;
        margin-bottom: 4px;
        display: -webkit-box;
        overflow: hidden;
    }

    & .viewer-rating {
        font-size: 13.01px;
        font-weight: 700;
        line-height: 1.337;
        text-transform: initial;

        & .viewer-rating--filled {
            color: #FFD700;
        }
        & .viewer-rating--empty {
            color: ${colors.text.gray};
        }
    }

    & .release-year {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
    }

    & .duration {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
    }

    & .mpaa-rating {
        font-size: 13.01px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
        white-space: nowrap;
        min-width: 24px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    & .mpaa-rating>span {
        background: ${colors.background.grey};
        border-radius: 4px;
        color: ${colors.text.white};
        line-height: 1.337;
        white-space: nowrap;
        min-width: 20px;
        padding: 2px 4px 1.01px;
    }

`;

export const MediaSynopsis = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    color: ${colors.text.gray};
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-height: calc(var(21.39px) * 3);
    margin-top: 8px;
    overflow: hidden;
    display: -webkit-box;

`;

export const MediaSynopsisModal = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    max-height: 90px;
    margin-top: 8px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;

`;

export const MediaHighlight = styled.span`
    font-size: 13.01px;
    font-weight: 700;
    line-height: 1.337;
    text-transform: initial;
    color: ${colors.text.gray};
    margin-top: 8px;
    display: none;
`;

export const MediaGenre = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    color: ${colors.text.gray};
    margin-top: 8px;

    & > span {
        margin-right: 12px;
        position: relative;

        &::after {
            content: '◦';
            font-size: 14px;
            font-weight: 400;
            line-height: 1.337;
            color: ${colors.text.gray};
            width: 12px;
            height: 12px;
            position: absolute;
            top: 50%;
            right: -15.01px;
            transform: translateY(calc(-50% + 1.01px));
        }

        &:last-of-type {
            margin-right: 0;

            &::after {
                display: none;
            }
        }
    }
`;

export const MediaGenreModal = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    margin-top: 8px;

    & > span {
        margin-right: 12px;
        position: relative;

        &::after {
            content: '◦';
            ${types.body.normal}
            line-height: 1.337;
            color: ${colors.text.gray};
            width: 12px;
            height: 12px;
            position: absolute;
            top: 50%;
            right: -15.01px;
            transform: translateY(calc(-50% + 1.01px));
        }

        &:last-of-type {
            margin-right: 0;

            &::after {
                display: none;
            }
        }
    }
`;

export const MediaCrew = styled.div`
    margin-top: 8px;
`;

export const CrewItem = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    color: ${colors.text.gray};
    margin-top: 0;
    margin-bottom: 8px;

    &:last-of-type {
        margin-bottom: 0;
    }

    & > span {
        font-weight: 700;
        display: block;
    }
`;

export const MediaCrewModal = styled.div`
    margin-top: 8px;
`;

export const CrewModalItem = styled.div`
    font-size: 13.01px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    margin-top: 0;
    margin-bottom: 8px;

    &:last-of-type {
        margin-bottom: 0;
    }

    & > span {
        font-weight: 700;
        display: block;
    }
`;
export const MediaRatingPlaylist = styled.div`
  margin: 8px 0 4px 0;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  color: ${({ theme }) => theme.cardText};

  svg {
    fill: currentColor;
    color: currentColor;
  }
`;


export const MediaRating = styled.div`
    margin: 8px 0 4px 0;
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
`;


export const MediaCard = styled.article`
    position: relative;
    z-index: 5;

    &.hover-intent:not(.is-mobile) {
        z-index: 15;

        & .media-card--wrapper {
            transform: scale(1.063);
            transition: all 0.3s ease-out;
        }
    }
`;

export const MediaCardWrapper = styled.div<{ isSelected?: boolean }>`
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    will-change: transform;
    transition: all 0.3s ease-out;
    border: ${({ isSelected, theme }) => isSelected ? `2px solid ${theme.borderContrast}` : `1px solid ${theme.cardSeparator}`};
    border-radius: 8px;
    
    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            height: auto;
            display: block;
        }
    }
    @media (min-width: 992px) {
        
    }
    @media (min-width: 1200px) {
        
    }
    @media (min-width: 1400px) {
        
    }
`;
export const StyledText = styled.div`
  ${types.headers.small}
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  white-space: nowrap;
  color: ${({ theme }) => theme.cardText};
  svg {
    margin-right: 5px;
    color: inherit;
  }
  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: inherit;
  }
`;

export const TrailerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.watchButtonBg};
  color: ${({ theme }) => theme.watchButtonColor};
  border: 1px solid transparent;
  padding: 6px 10px 6px 12px;
   ${types.body.normal}
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.watchButtonHover};
    cursor: pointer;
  }

  &:focus {
    outline: none;
    border: none;
  }

  svg {
    margin-top: -1px;
  }
`;

export const StyledPlayFill = styled(PlayFill)`
    color: ${({ theme }) => theme.cardBg};
`;


export const IconWrapper = styled.button`
  background-color: ${({ theme }) => theme.watchButtonBg};
  color: ${({ theme }) => theme.watchButtonColor};
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(63, 62, 62, 0.4);
    cursor: pointer;
  }

  &:focus {
    outline: none;
    border: none;
  }

`;

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 12px;
`;

export const InfoItemGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap:10px;

 p {
    ${types.body.small}
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
     
 }
  span {
    ${types.body.small}
    font-weight: 400;
    margin-left: 4px;
    word-wrap: break-word;
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const GenrePills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  color: ${({ theme }) => theme.cardText};
  padding-top:10px;
  margin-top: 10px;
`;

export const Genre = styled.div`
    ${types.headers.normal}
    padding: 0px 5px;
    border: 1px solid ${({ theme }) => theme.borderContrast};
    border-radius: 20px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.cardText};
`;

export const TrailerSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top:10px;
`;
